import * as React from "react";
import * as ReactDOM from "react-dom";
import { Router, Route, Redirect, hashHistory, browserHistory } from 'react-router';
import { Provider } from 'react-redux';
import { IntegrationAccount } from './integration'
import { store } from './store';
import * as jQuery from 'jquery';
import { insertHeader } from './insertHeader';
import smoothscroll from 'smoothscroll-polyfill';

//css class
import "../node_modules/font-awesome/css/font-awesome.css"

import './static/css/bootstrap.css';
import './static/css/bootstrap-multiselect.css'
import './static/css/styles.css';
import './static/css/adaptive.css';
import './static/css/app.css';
import './static/css/custom.css';
import './static/css/circle.css';
import './static/css/fonts.css';
import './static/css/swiper.css';
import './static/css/react-select.css';



import ProgramsPage from "./components/program"
import Request from './components/request'
import Content from './components/request/Content'
import ModalAlert from "./components/modal";
import {Modal} from "react-modal";

smoothscroll.polyfill();

const account = new IntegrationAccount("/", hashHistory);
account.start();

insertHeader();

ReactDOM.render(
    <Provider store={store}>
        <>
            <Router history={hashHistory} >
                <Redirect from="/" to="/list"/>
                <Route path='/list' component={ProgramsPage}/>
                <Route path='/create' component={Request}>
                    <Route path='/create/:form/:values' component={Content}/>
                </Route>
                <Route path='/view' component={Request}>
                    <Route path='/view/:form/:values' component={Content}/>
                </Route>
            </Router>
            <ModalAlert />
        </>
    </Provider>,
     document.getElementById("root")
 );

jQuery(document).ajaxError(function(e, xhr, settings, exception){
    if(xhr.status == 401){
        //window.location.href = "/";
    }
});



// WEBPACK FOOTER //
// ./src/index.tsx